/*
 *
 * OperationAdditionalInfo
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 01-Jul-2024
 */

import OperationAdditionalInfo from './OperationAdditionalInfoContainer'

export default OperationAdditionalInfo
